import { Flex } from 'antd';
import {
  BrainFunctionVisualisation,
  DynamicBrainFunctionVisualisation,
  RequiredVisualisationData
} from 'lib/utils/business/brainfunction-categories/types';
import { BrainFunctionVisualisationComponent } from './components/brainfunction-visualisation';

export function DialBreakdown(props: {
  patientInfo: RequiredVisualisationData;
  composedVisualisation: DynamicBrainFunctionVisualisation;
  sourceVisualisations: BrainFunctionVisualisation[];
}) {
  return (
    <Flex gap={24}>
      {props.sourceVisualisations.map(visualisation => (
        <BrainFunctionVisualisationComponent
          key={visualisation.label}
          visualisation={visualisation}
          visualisationData={props.patientInfo}
        />
      ))}
    </Flex>
  );
}
